var render = function render(){
  var _vm$value;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "지원자 정보",
      "fullscreen": "",
      "persistent": "",
      "width": "1224",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "mb-20 mb-lg-40",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, [_c('application-view-title', _vm._b({
    staticClass: "mb-12 mb-lg-26"
  }, 'application-view-title', {
    value: _vm.value
  }, false)), _c('v-tabs', {
    staticClass: "v-tabs--underline",
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("이력서")]), _c('v-tab', [_vm._v("마이스펙이력 (" + _vm._s(_vm.micepecRecordsLength) + ")")]), _c('v-tab', [_vm._v("추가질문답변")]), _c('v-tab', [_vm._v("문자보내기")]), _c('v-tab', [_vm._v("메모하기")]), _vm.isRecruit ? _c('v-tab', [_vm._v("마이스펙인증")]) : _vm._e(), !_vm.hideOthers ? _c('v-tab', [_vm._v("지원이력")]) : _vm._e()], 1)], 1), _c('v-tabs-items', {
    staticClass: "h-100 scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('tab-resume', {
    attrs: {
      "value": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.resume
    }
  }), _c('tab-micepec-records', _vm._b({}, 'tab-micepec-records', {
    value: _vm.value
  }, false)), _c('tab-questions', _vm._b({}, 'tab-questions', {
    value: _vm.value
  }, false)), _c('tab-textings', _vm._b({}, 'tab-textings', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false)), _c('tab-memo', {
    attrs: {
      "application": _vm.value
    }
  }), _vm.isRecruit ? _c('tab-certify', _vm._b({
    on: {
      "input": function (item) {
        return _vm.$emit('input', item);
      }
    }
  }, 'tab-certify', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false)) : _vm._e(), !_vm.hideOthers ? _c('tab-others', _vm._b({
    on: {
      "input": function (item) {
        return _vm.$emit('input', item);
      }
    }
  }, 'tab-others', {
    value: _vm.value
  }, false)) : _vm._e()], 1), false ? void 0 : _vm.withdrawn ? [_c('v-overlay', {
    staticClass: "black--text text-h1 font-weight-black",
    staticStyle: {
      "pointer-events": "none",
      "opacity": "0.25"
    },
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }, [_vm._v(" 탈퇴회원 ")])] : _vm.isRevoked ? [_c('v-overlay', {
    staticClass: "black--text text-h1 font-weight-black",
    staticStyle: {
      "pointer-events": "none",
      "opacity": "0.25"
    },
    attrs: {
      "absolute": "",
      "color": "transparent"
    }
  }, [_vm._v(" 지원취소 ")])] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }